import React, { useState, useEffect } from 'react'; // <-- useEffect ajouté
import { useSelector, useDispatch } from 'react-redux';
// Retrait de Tag inutilisé
import { Table, Button, Space, Popconfirm, Typography, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
// Importer les actions Redux depuis le bon chemin
import { fetchPublicHolidays, deletePublicHoliday } from '../../redux/slices/planning/planningThunks';
import dayjs from 'dayjs';
import PublicHolidayFormModal from './PublicHolidayFormModal'; // Le composant Modal

const { Title, Text } = Typography; // Ajouter Text

function PublicHolidaysPage() {
  const dispatch = useDispatch();
  const publicHolidays = useSelector((state) => state.planning?.publicHolidays || []);
  const loadingHolidays = useSelector((state) => state.planning?.loading?.publicHolidays || false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingHoliday, setEditingHoliday] = useState(null);

  useEffect(() => {
    dispatch(fetchPublicHolidays());
  }, [dispatch]);

  const handleDelete = (id) => {
    dispatch(deletePublicHoliday(id))
      .unwrap()
      .then(() => message.success('Jour férié supprimé avec succès'))
      .catch(() => message.error('Erreur lors de la suppression'));
  };

  const showAddModal = () => {
    setEditingHoliday(null);
    setIsModalVisible(true);
  };

  const showEditModal = (holiday) => {
    setEditingHoliday(holiday);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingHoliday(null);
  };

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => dayjs(date).isValid() ? dayjs(date).format('DD/MM/YYYY') : 'Date invalide',
      sorter: (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix(),
      width: 150,
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} title="Modifier" />
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer ce jour férié ?"
            onConfirm={() => handleDelete(record.id)}
            okText="Oui"
            cancelText="Non"
          >
            <Button icon={<DeleteOutlined />} danger title="Supprimer" />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={3}>Gestion des Jours Fériés</Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={showAddModal}>
          Ajouter un Jour Férié
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={publicHolidays}
        loading={loadingHolidays} // Utiliser l'état de chargement spécifique
        rowKey="id"
        bordered
      />
      {isModalVisible && (
          <PublicHolidayFormModal
            visible={isModalVisible}
            onCancel={handleCancel}
            holiday={editingHoliday}
          />
      )}
    </>
  );
}

export default PublicHolidaysPage;